// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — radio-popup.styled.classic.js, новая — radio-popup.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './radio-popup.styled.classic';
import * as cp from './radio-popup.styled.cp';

export const Arrow = isCp ? cp.Arrow : classic.Arrow;
export const Buttons = isCp ? cp.Buttons : classic.Buttons;
export const Content = isCp ? cp.Content : classic.Content;
export const Item = isCp ? cp.Item : classic.Item;
